var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackArrow = function SvgBackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.042 5.834 2.375 2.375a.763.763 0 0 1 .24.583.85.85 0 0 1-.833.844.776.776 0 0 1-.595-.24L.417 5.584A.8.8 0 0 1 .167 5a.8.8 0 0 1 .25-.583L4.229.605a.776.776 0 0 1 .594-.24.85.85 0 0 1 .833.844.763.763 0 0 1-.24.583L3.043 4.167h9.291c.236 0 .434.08.594.24.16.16.24.357.24.593s-.08.434-.24.594a.806.806 0 0 1-.594.24H3.042Z",
    fill: "#53B741"
  })));
};
export default SvgBackArrow;